import React from "react";
import { Paper, Box, Typography, Divider } from "@mui/material";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

// استيراد الأيقونات
import StairsRoundedIcon from '@mui/icons-material/StairsRounded';
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded';
import TitleRoundedIcon from '@mui/icons-material/TitleRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import { GridLayout } from "../utils/layouts";

export default function InfoBar() {
  const { 
    lesson, 
    subject, 
    classInfo, 
    school, 
    loading 
  } = useSelector((state) => state.session) || {};

  // 2. دالة مساعدة لإنشاء "الباج" الأنيق
  const renderField = (label, value, IconComponent) => (
    <Paper
      variant="glass"
      sx={{
            textOverflow:'ellipsis',
            overflow:'hidden'
          }}
    >
      {/* حاوية الأيقونة */}
        <Typography 
          variant="sectionTitle"
          noWrap
          
        >
          {value || "غير متوفر"}
        </Typography>

    </Paper>
  );

  return (
    <Paper elevation={0} variant="section">
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, }}>
        <InfoRoundedIcon color="secondary" />
        <Typography variant="sectionTitle">
          معلومات الدرس الأساسية
        </Typography>
      </Box>

      <Divider sx={{ mb: 2.5 }} />

      <GridLayout>
        {renderField("المدرسة", school?.name, SchoolRoundedIcon)}
        {renderField("الصف", classInfo?.name, StairsRoundedIcon)}
        {renderField("المادة", subject?.name, MenuBookRoundedIcon)}
        {renderField("عنوان الدرس", lesson?.title, TitleRoundedIcon)}
        
        {renderField(
          "التاريخ", 
          lesson?.date ? dayjs(lesson.date).format("YYYY/MM/DD") : "", 
          CalendarMonthRoundedIcon
        )}
</GridLayout>
    </Paper>
  );
}